import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiConfigService } from '../../ssr-services/api-config/api-config.service';
import { CacheService } from '../../ssr-services/cache/cache.service';

@Injectable({
  providedIn: 'root',
})
export class InventoryManagementService {
  protected http = inject(HttpClient);

  protected apiConfig = inject(ApiConfigService);

  protected cacheService = inject(CacheService);

  /**
   * Returns true if inventory is available
   * @param imsiId
   * @returns
   */
  public checkInventoryAvailability(imsiId: string | number): Observable<boolean> {
    return this.http
      .get<{ available: boolean }>(this.apiConfig.url('inventory/check'), {
        params: {
          customerId: this.cacheService.cachedContent()?.cache.customerId || '',
          imsi: imsiId.toString(),
        },
      })
      .pipe(map(({ available }) => available));
  }
}
